import React from 'react';
import './drawer.scss';
import PropTypes from 'prop-types';
import Icon from 'components/mweb/Icon/Icon';
import { Drawer as AntdDrawer } from 'antd';
const Drawer = props => {
  const {
    visible,
    onClose,
    destroyOnClose = true,
    closable = true,
    maskClosable = true,
    getContainer = false,
    title,
    footer,
    placement,
    width,
    children,
    className,
    afterVisibleChange,
  } = props;
  const drawerProps = {
    visible,
    onClose,
    footer,
    destroyOnClose,
    maskClosable,
    placement,
    closable,
    width,
    afterVisibleChange,
    getContainer,
    className: `hb-drawer ${className}`,
  };

  const onCloseDrawer = () => {
    // document.body.style.overflow = 'auto';
    onClose();
  };

  // if (visible) document.body.style.overflow = 'hidden';
  return (
    <AntdDrawer
      {...drawerProps}
      closable={false}
      id="hb-drawer"
      style={{ transform: 'translateX(0)' }}
      // onClose={onCloseDrawer}
    >
      {(title || closable) && (
        <div className="hb-drawer--header">
          <div className="hb-drawer--header--title">
            {title ? title : <span>&nbsp;</span>}
          </div>
          {closable && (
            <div
              className="hb-drawer--header--close-icon"
              onClick={onCloseDrawer}
            >
              <Icon size={24} class="icon-common-close" />
            </div>
          )}
        </div>
      )}
      {children}
    </AntdDrawer>
  );
};

Drawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  footer: PropTypes.object,
  destroyOnClose: PropTypes.bool,
  maskClosable: PropTypes.bool,
  closable: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  afterVisibleChange: PropTypes.func,
};

export default Drawer;
